<div *ngIf="errorMessage" class="error-bar fullwidth">
  <span>
    <span *ngIf="errorMessage.title">{{ errorMessage.title }}: </span>
    {{ errorMessage.message }}
  </span>
  <button class="uk-button uk-button-nobutton" (click)="closeError()">
    <i class="fas fa-times"></i>
  </button>
</div>
